import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import useDebounce from 'modules/common/components/UseDebounce';
import * as actions from '../action';
import * as c from '../constant';
import PermissionContent from './PermissionContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

const form = {
  keyword: '',
};

function PermissionContainer({
  match,
  history,
  getPermission,
  // getPermissionList,
  permissionList,
  permissionListPager,
  isLoading,
  removePermission,
  showPermission,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const permissions = getJson('permissions');

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Permission',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data} id={data.id} />,
      title: 'Update Permission',
      modalSize: 'modal-md',
    });
  };

  const handleRemove = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      'Are you sure, you want to remove?',
      () => {
        removePermission(data.id, () => {
          getPermission({}, (response) => {
            const id = _.get(response, 'data.0.id');
            history.push(`/permission-management/${id}`);
            showPermission(id);
          });
        });
      },
      () => { },
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  useEffect(() => {
    getPermission();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  const param = {
    q: formData.keyword,
    sort_by: 'asc'
  };

  useEffect(() => {
    if (debouncedSearchTerm) {
      getPermission({ is_paginated: 1, q: formData.keyword, sort_by: 'asc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:permissionId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            moduleName="Permissions"
            getData={getPermission}
            setParams={param}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'keyword') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:permissionId?`}
            listName="Permissions"
            label="Permissions"
            renderItem={(item) => (
              <div className="px-3 py-3">
                <span style={{ color: '#2f89fc', fontWeight: 'bold' }}>
                  {_.get(item, 'attributes.name')}{' '}
                </span>
                <br />
              </div>
            )}
            isLoading={isLoading}
            selected={params.permissionId}
            data={permissionList}
            dataPager={permissionListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  {Acl(permissions, ['CREATE PERMISSION']) && (
                    <Route
                      path={`${match.path}/:permissionId?`}
                      render={() => (
                        <PermissionContent
                          handleAddModal={handleAddModal}
                          handleEdit={handleEdit}
                          handleRemove={handleRemove}
                        />
                      )}
                    />
                  )}
                </Switch>
                <Route
                  path={`${match.path}/:permissionId?`}
                  render={() =>
                    !params.permissionId && permissionList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(permissionList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

PermissionContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getPermission: PropTypes.instanceOf(Function).isRequired,
  permissionList: PropTypes.instanceOf(Array).isRequired,
  permissionListPager: PropTypes.instanceOf(Object).isRequired,
  removePermission: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  showPermission: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissionList: _.get(api, `${c.GET_PERMISSION}.list`) || [],
  permissionListPager: _.get(api, `${c.GET_PERMISSION}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PERMISSION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PermissionContainer);
